import { render, staticRenderFns } from "./ContactsInformation.vue?vue&type=template&id=55c45f56&scoped=true"
import script from "./ContactsInformation.vue?vue&type=script&lang=js"
export * from "./ContactsInformation.vue?vue&type=script&lang=js"
import style0 from "./ContactsInformation.vue?vue&type=style&index=0&id=55c45f56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c45f56",
  null
  
)

export default component.exports